import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { RestAPIService } from 'src/app/services/restapi.service';
import { LoginModel } from 'src/app/modules/login/models/loginModel';
import { environment } from 'src/environments/environment';
import { FormControl, Validators} from '@angular/forms';
import { LoginResponseModel } from '../models/loginResponseModel';
import { ForgotPasswordModel } from '../models/forgotPasswordModel';
import { ToastService } from 'src/app/services/toaster.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {

    constructor(private authService: AuthService, private router: Router, public _restAPI: RestAPIService,private toast: ToastService, private dialog: MatDialog) {
        this._restAPI.loading  = false;
        this.dialog.closeAll();
    }
    loginModel: LoginModel = new LoginModel();
    forgotPasswordModel: ForgotPasswordModel = new ForgotPasswordModel();
    email = new FormControl('', [Validators.required, Validators.email]);
    emailId = new FormControl('', [Validators.required, Validators.email]);
    password = new FormControl('', [Validators.required]);
    rememberMe = new FormControl(false, [Validators.required]);
    currentYear = new Date().getFullYear();
    environment = environment;
    showForgotPassword: boolean = false;
    async ngOnInit() {
        if(this.authService.isAuthenticated()){
            await this.router.navigate(['/']);
        }
    }

    login(): void{
        if (this.email.invalid || this.password.invalid) {
            this.email.markAsTouched();
            this.password.markAsTouched();
            return;
          }
        this._restAPI.loading  = true;
        let postData = {
            email: this.loginModel.email,
            password: this.loginModel.password,
            rememberMe: this.loginModel.rememberMe ?? false
        };

        this._restAPI.post<LoginResponseModel>(environment.apiURL + 'api/user/login', postData).subscribe({
            next: (results) => {
                this._restAPI.loading  = false;
                if(results.authenticationResult?.resetToken){
                    this.router.navigate(['/resetpassword/'+results.authenticationResult?.resetToken]);
                }
                else {
                    this.authService.login(results);
                    this.router.navigate(['/']);
                }
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error);}
        });
    }

    hide = signal(true);
    clickEvent(event: MouseEvent) {
        this.hide.set(!this.hide());
        event.stopPropagation();
    }

    toggleForgotPassword() {
        this.showForgotPassword = !this.showForgotPassword;
    }

    forgotPassword(): void{
        if (this.email.invalid) {
            this.email.markAsTouched();
            this.toast.error('Please enter your email.');
            return;
        }
        this._restAPI.loading  = true;
        let postData = {
            emailId: this.forgotPasswordModel.emailId
        };

        this._restAPI.post<boolean>(environment.apiURL + 'api/usermanagement/forgotpassword', postData).subscribe({
            next: (results) => {
                this._restAPI.loading  = false;
                this.toast.show('If your email is registered, you will receive a password reset link shortly.');
                this.showForgotPassword = false;
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error);}
        });
    }

    cancelForgotPassword(): void{
        this.showForgotPassword = false;
    }
}